import { Box } from "@amzn/awsui-components-react";
import { formatCount } from "../../utils/mapReleaseDashboard/mapPackValidationSummaryFormat";
import CopyTextField from "../offline-maps/CopyTextField";

/** Highlight increases independently in each category, even when total PNF decreases. */
const RecostPnfCount = ({ value, control, signed = false, copyable = false }: {
    value: number | null | undefined;
    control?: number | null;
    signed?: boolean;
    copyable?: boolean;
}) => {
    const increased = value != null && (signed ? value > 0 : control != null && value > control);
    const content = (
        <Box color={increased ? "text-status-error" : "inherit"} fontWeight={increased ? "bold" : "normal"}>
            {signed && value != null && value > 0 ? "+" : ""}{formatCount(value ?? null)}
        </Box>
    );
    return copyable && value != null
        ? <CopyTextField content={content} altCopyText={String(value)}/>
        : content;
};

export default RecostPnfCount;
